import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent(
    'Mortal Strike',
    'ability_warrior_savageblow',
    ['A vicious strike that deals weapon damage plus 85 and wounds the target, reducing healing taken by 50% for 10 sec.'],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    '30 Rage',
    'Melee range',
    'Instant cast',
    '6 sec cooldown'
  ),
  null,
  null,
]

export default tier7
